// Note! Whenever a URL is added / removed / changed, the sitemap must be manually updated!!
// It is found straight down in the "src" folder.
//
// Layouts
import MainLayout from '@/layouts/main/component'
import GeneralLayout from '@/layouts/general/component'
import HeaderLayout from '@/layouts/header/component'
import TwoColLayout from '@/layouts/two-col/component'
import ErrorLayout from '@/layouts/error/component'

// Pages
import IndexPage from '@/pages/index/component'
import GiftCardsPage from '@/pages/gift-cards/component'
import FramesPage from '@/pages/frames/component'
import TheArtistsPage from '@/pages/about/the-artists/component'
import ContactPage from '@/pages/about/contact/component'
import GeneralTermsPage from '@/pages/about/general-terms/component'
import PrivacyPolicyPage from '@/pages/about/privacy-policy/component'
import OurStoryPage from '@/pages/about/our-story/component'
import FAQPage from '@/pages/faq/component'
import CheckoutPage from '@/pages/checkout/component'
import CheckoutConfirmationPage from '@/pages/checkout/confirm/component'
import PostersPage from '@/pages/posters/component'
import NotFoundPage from '@/pages/errors/404/component'

// Poster generation pages
import PosterPage from '@/pages/poster/component'

export default [
  // The language is always the first parameter in the URL. Check main.js for the router's beforeEach handler, making
  // sure to forward if we have a bad argument here)
  {
    path: '',
    component: MainLayout,
    props: true,
    children: [
      {
        path: '',
        component: GeneralLayout,
        children: [
          {
            name: 'index',
            path: '',
            component: IndexPage,
            meta: {
              title: 'titleIndex',
              desc: 'metaDescIndex'
            }
          },
          {
            name: 'posters',
            path: 'f%C3%B6delsetavlor',
            component: PostersPage,
            meta: {
              title: 'titlePosters',
              punchLine: 'punchlinePosters',
              desc: 'metaDescPosters'
            },
            children: [
              {
                name: 'artist',
                path: ':artist',
                props: true,
                meta: {
                  title: 'titleArtist',
                  punchLine: 'punchlineArtist',
                  desc: 'metaDescArtist'
                }
              }
            ]
          },

          // Error pages.
          {
            path: 'error',
            component: ErrorLayout,
            children: [
              {
                name: 'notFound',
                component: NotFoundPage,
                path: '404',
                meta: {
                  title: 'titleNotFound',
                  punchLine: 'punchlineNotFound',
                  desc: 'metaDescNotFound'
                }
              }
            ]
          }
        ]
      },
      {
        path: '',
        component: HeaderLayout,
        props: { background: 'FAQ' },
        children: [
          {
            name: 'contact',
            path: 'om-oss/kontakt',
            component: ContactPage,
            meta: {
              title: 'titleContact',
              punchLine: 'punchlineContact',
              desc: 'metaDescContact'
            }
          }
        ]
      },
      {
        path: '',
        component: HeaderLayout,
        props: { background: 'FAQ' },
        children: [
          {
            name: 'general-terms',
            path: 'om-oss/allm%C3%A4nna-villkor',
            component: GeneralTermsPage,
            meta: {
              title: 'titleGeneralTerms',
              punchLine: 'punchlineGeneralTerms',
              desc: 'metaDescGeneralTerms'
            }
          }
        ]
      },
      {
        path: '',
        component: HeaderLayout,
        props: { background: 'FAQ' },
        children: [
          {
            name: 'privacy-policy',
            path: 'om-oss/integritetspolicy',
            component: PrivacyPolicyPage,
            meta: {
              title: 'titlePrivacyPolicy',
              punchLine: 'punchlinePrivacyPolicy',
              desc: 'metaDescPrivayPolicy'
            }
          }
        ]
      },
      {
        path: '',
        component: HeaderLayout,
        props: { background: 'staff' },
        children: [
          {
            name: 'our-story',
            path: 'om-oss/v%C3%A5r-ber%C3%A4ttelse',
            component: OurStoryPage,
            meta: {
              title: 'titleOurStory',
              punchLine: 'punchlineOurStory',
              desc: 'metaDescOurStory'
            }
          }
        ]
      },
      {
        path: '',
        component: HeaderLayout,
        props: { background: 'artists' },
        children: [
          {
            name: 'the-artists',
            path: 'om-oss/konstn%C3%A4rerna',
            component: TheArtistsPage,
            meta: {
              title: 'titleTheArtists',
              punchLine: 'punchlineTheArtists',
              desc: 'metaDescTheArtists'
            }
          }
        ]
      },
      {
        path: '',
        component: HeaderLayout,
        props: { background: 'faq' },
        children: [
          {
            name: 'faq',
            path: 'vanliga-fr%C3%A5gor',
            component: FAQPage,
            meta: {
              title: 'titleFAQ',
              punchLine: 'punchlineFAQ',
              desc: 'metaDescFAQ'
            }/* 2DO - Check aliases for all pages ,
            alias: [
              'help',
              'hilfe',
              'hjelp',
              'hjaelp',
              'auta',
              'aide',
              'help',
              'help',
              'ayuda'
            ] */
          }
        ]
      },
      {
        path: '',
        component: HeaderLayout,
        props: { background: 'giftcard' },
        children: [
          {
            name: 'gift-cards',
            path: 'presentkort',
            component: GiftCardsPage,
            meta: {
              title: 'titleGiftCards',
              punchLine: 'punchlineGiftCards',
              desc: 'metaDescGiftCards'
            }
          }
        ]
      },
      {
        path: '',
        component: HeaderLayout,
        props: { background: 'frames' },
        children: [
          {
            name: 'frames',
            path: 'ramar',
            component: FramesPage,
            meta: {
              title: 'titleFrames',
              punchLine: 'punchlineFrames',
              desc: 'metaDescFrames'
            }
          }
        ]
      },
      {
        path: '',
        component: TwoColLayout,
        children: [
          {
            name: 'checkout',
            path: 'kassa',
            component: CheckoutPage,
            meta: {
              title: 'titleCheckout'
            }
          }
        ]
      },

      // Posters
      {
        path: '',
        component: TwoColLayout,
        props: { menu: true },
        children: [
          {
            name: 'posterColorPresentation',
            path: 'f%C3%B6delsetavla/:poster/:colorName/:presentation',
            props: true,
            component: PosterPage,
            meta: {
              title: 'titlePoster',
              punchLine: 'punchlinePoster',
              desc: 'metaDescPoster'
            }
          }
        ]
      },
      {
        path: '',
        component: TwoColLayout,
        props: { menu: true },
        children: [
          {
            name: 'posterColor',
            path: 'f%C3%B6delsetavla/:poster/:colorName',
            props: true,
            component: PosterPage,
            meta: {
              title: 'titlePoster',
              punchLine: 'punchlinePoster',
              desc: 'metaDescPoster'
            }
          }
        ]
      },
      {
        path: '',
        component: TwoColLayout,
        props: { menu: true },
        children: [
          {
            name: 'poster',
            path: 'f%C3%B6delsetavla/:poster',
            props: true,
            component: PosterPage,
            meta: {
              title: 'titlePoster',
              punchLine: 'punchlinePoster',
              desc: 'metaDescPoster'
            }
          }
        ]
      },

      // No layout.
      {
        name: 'checkout-confirmation',
        path: 'kassa/orderbekr%C3%A4ftelse',
        component: CheckoutConfirmationPage,
        meta: {
          title: 'titleCheckoutConfirmation'
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/routes.sv.js